module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/how_to_enjoy_photography_case5-30e73e1c85d56f97b14b6cb3d5dffd19.jpg";